import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

function CardSlide({
  classText,
  title,
  message,
  path,
  register,
  classGrid,
  classImg,
  image,
  alt,
  number,
  totalItems,
}) {
  return (
    <div className="root-slide">
      <div className="slide">
        <div className={`slider-mobile ${classGrid}`}>
          <img className={classImg} src={image} alt={alt} />
        </div>
        <div className={classText}>
          <h1 className="title-1">{title}</h1>
          <p className="txt-p">{message}</p>
          <Link className="btn-orange register" to={path}>
            {register}
          </Link>
        </div>
        <div className={`slider-desktop ${classGrid}`}>
          <img className={classImg} src={image} alt={alt} />
        </div>
      </div>
      <div className="number">
        <h3 className="font-size-20">
          <strong>{number}</strong>/
        </h3>
        <h3 className="font-size-13">{totalItems}</h3>
      </div>
    </div>
  );
}

CardSlide.propTypes = {
  classText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  register: PropTypes.string.isRequired,
  classGrid: PropTypes.string.isRequired,
  classImg: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
};

export default CardSlide;
